import { InputAdornment, TextField, Typography } from "@material-ui/core";
import { useState } from "react"
import BgLeft from '../assets/bgleftPass.svg';
import Bg from '../assets/bgrightPass.svg';
import LogoLogin from '../assets/LogoLogin.png';
import Success from '../assets/sukses_pass.png';
import Username from '../assets/ic_un.png';
import { useHistory } from "react-router";


export default function SuccessChangePass(props) {
    const history = useHistory()

    const [showPass, setShowPass] = useState(false)

    return (
        <div style={{ height: '100vh', display: 'flex', backgroundColor: '#278863', width: '100%' }}>
            <img src={BgLeft} style={{ position: 'absolute', left: 0, bottom: 0, width: '47%' }} />
            <img src={Bg} style={{ position: 'absolute', right: 0, bottom: 0, width: '30%' }} />
            <div style={{ width: '100%', height: '100%' }}>
                <div style={{ width: '100%', height: '20%', display: 'flex', padding: '2%', justifyContent: 'space-between', paddingLeft: '3%', paddingRight: '3%' }}>
                    <img src={LogoLogin} style={{ height: '9vh', width: '35%', contain: 'layout' }} />
                    {/* <button style={{ backgroundColor: '#176f4d', height: '4vh', width: '7%', borderRadius: '4vh', alignItems: 'center', display: 'grid', cursor: 'pointer', outline: 'none', borderColor: 'transparent' }}>
                        <Typography style={{ color: '#fff', fontSize: '1vw', textAlign: 'center' }}>Login </Typography>
                    </button> */}
                </div>
                <div style={{ width: '100%', height: '80%', display: 'grid', justifyItems: 'center' }}>
                    <div style={{ width: '45%', height: '90%', backgroundColor: '#e8ffed', contain: 'layout', borderRadius: '4vh' }}>
                        <div style={{ width: '100%', height: '100%', textAlign: 'center', padding: '3%' }}>
                            <img src={Success} style={{ height: '24vh', width: '35%', contain: 'layout', marginTop: '3%' }} />
                            <Typography style={{ color: '#278863', fontSize: '2vw', textAlign: 'center', marginTop: '5%', fontFamily: 'Poppins', fontWeight: '500' }}>Sukses !</Typography>
                            <div style={{ display: 'grid', width: '100%', justifyItems: "center", marginTop: '2%', fontWeight: 'bold' }}>
                                <Typography style={{ color: 'black', fontSize: '1vw', textAlign: 'center', width: '50%', fontWeight: 'bold', fontFamily: 'Poppins' }}>Kata sandi anda sukses diperbarui, silahkan login ke Web Admin</Typography>
                            </div>
                            <div style={{ width: '100%', display: 'grid', justifyItems: 'center' }}>
                                <button
                                    onClick={() => {
                                        history.push('/')
                                    }}
                                    style={{ backgroundColor: '#176f4d', height: '4vh', width: '25%', borderRadius: '4vh', alignItems: 'center', display: 'grid', cursor: 'pointer', outline: 'none', borderColor: 'transparent', marginTop: '8%' }}>
                                    <Typography style={{ color: '#fff', fontSize: '1vw', textAlign: 'center', fontFamily: 'Poppins' }}>Login</Typography>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}